/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Redo_TitleInputs */

const en_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const fr_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rétablir`)
};

const de_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

const it_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifare`)
};

const ru_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переделать`)
};

const es_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehacer`)
};

const zh_cn2_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重做`)
};

const ja_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直す`)
};

const hi_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से करना`)
};

const pt_pt2_toolbar_secondary_redo_title = /** @type {(inputs: Toolbar_Secondary_Redo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refazer`)
};

/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Toolbar_Secondary_Redo_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_redo_title = /** @type {((inputs?: Toolbar_Secondary_Redo_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Redo_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_redo_title(inputs)
	if (locale === "de") return de_toolbar_secondary_redo_title(inputs)
	if (locale === "it") return it_toolbar_secondary_redo_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_redo_title(inputs)
	if (locale === "es") return es_toolbar_secondary_redo_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_redo_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_redo_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_redo_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_redo_title(inputs)
	return en_toolbar_secondary_redo_title(inputs)
});